import { FC, ReactNode } from 'react';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import clsx from 'clsx';

import classes from './FloorMap.module.scss';

export interface FloorMapFallbackProps {
  children?: ReactNode;
}

export const FloorMapFallback: FC<FloorMapFallbackProps> = ({ children }) => {
  return (
    <div
      className={clsx(
        classes.container,
        classes.border,
        classes.center,
        classes.fallback,
      )}
      data-testid='floorMapFallback'
    >
      <Typography>{children}</Typography>
    </div>
  );
};
